var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm._m(0);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "uppercase text-white bg-pink-600 rounded-xl px-2 py-1 text-2sm flex justify-center items-center"
  }, [_c('span', [_vm._v("Bêta")])]);

}]

export { render, staticRenderFns }